import React from 'react';
import PropTypes from 'prop-types';
import {Select} from './reduxForm.style';
const RenderDropdownList = ({input, data}) => (
  <Select
    {...input}
    onChange={input.onChange}
  >
    {data.map(value => (
      <option
        value={value}
        key={value}
      >
        {value}
      </option>
    ))}
  </Select>
);

RenderDropdownList.propTypes = {
  input: PropTypes.object,
  data: PropTypes.array
};

export default RenderDropdownList;



// WEBPACK FOOTER //
// ./components/ReduxForm/RenderDropdownList.js